import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
export const defaultComposerContainerState = {
    draftMode: 'uncontrolled',
    isExpanded: true,
    isActive: false,
    isComposing: false,
    status: 'idle',
    hasDraft: false,
    isDisabled: false,
};
export function setExpanded(state, isExpanded) {
    return { ...state, isExpanded };
}
export function setActive(state, isActive) {
    return { ...state, isActive };
}
export function setComposing(state, isComposing) {
    return { ...state, isComposing };
}
export function setStatus(state, status) {
    return { ...state, status };
}
export function setDraftState(state, draftState) {
    return { ...state, ...draftState };
}
export function setHasDraft(state, hasDraft) {
    // Preserve reference identity on no-op transitions so the frequent per-keystroke
    // dispatches from the draft tracker bail out of a re-render.
    return state.hasDraft === hasDraft ? state : { ...state, hasDraft };
}
export function setDisabled(state, isDisabled) {
    return state.isDisabled === isDisabled ? state : { ...state, isDisabled };
}
export function composerContainerReducer(state, action) {
    switch (action.type) {
        case 'SET_EXPANDED':
            return setExpanded(state, action.payload);
        case 'SET_ACTIVE':
            return setActive(state, action.payload);
        case 'SET_COMPOSING':
            return setComposing(state, action.payload);
        case 'SET_STATUS':
            return setStatus(state, action.payload);
        case 'SET_DRAFT_STATE':
            return setDraftState(state, action.payload);
        case 'SET_HAS_DRAFT':
            return setHasDraft(state, action.payload);
        case 'SET_DISABLED':
            return setDisabled(state, action.payload);
        default:
            return assertUnreachableValue(action);
    }
}
//# sourceMappingURL=reducers.js.map